function formatRate(rateStr: string) {
  if (rateStr === 'null') {
    return '';
  }
  const parseValue = parseFloat(rateStr);
  return isNaN(parseValue) ? rateStr : parseValue;
}

export {formatRate}
